import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { DevExtremeModule, DxDataGridModule } from 'devextreme-angular';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

@NgModule({
    imports: [
        CommonModule,

        // Forms
        ReactiveFormsModule,
        FormsModule,

        // Material
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatInputModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatDividerModule,
        MatStepperModule,
        MatMenuModule,
        MatToolbarModule,
        MatDialogModule,
        MatTableModule,
        MatTabsModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatRadioModule,
        MatOptionModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatRippleModule,
        MatChipsModule,
        MatPaginatorModule,

        // Devexpress DataGrid
        DxDataGridModule,
        DevExtremeModule,

        // Transloco
        TranslocoModule,

        // Keyboard shortcuts
        KeyboardShortcutsModule,

        // Routing
        RouterModule,
    ],
    exports: [
        CommonModule,

        // Forms
        ReactiveFormsModule,
        FormsModule,

        // Material
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatInputModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatDividerModule,
        MatStepperModule,
        MatMenuModule,
        MatToolbarModule,
        MatDialogModule,
        MatTableModule,
        MatTabsModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatRadioModule,
        MatOptionModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatRippleModule,
        MatChipsModule,

        // Devexpress DataGrid
        DxDataGridModule,
        DevExtremeModule,

        // Transloco
        TranslocoModule,

        // Keyboard shortcuts
        KeyboardShortcutsModule,

        // Routing
        RouterModule,
    ],
})
export class SharedModule {}
